import { Col, Row } from 'antd';

import { Button, ModalActionButtons } from 'components/ui';

import { type DataField, type HeaderMappingEntry, type PreviewDamage } from '../../types';
import { STEPS } from '../common';
import { LabelText, ValueText } from '../common.style';

type ConfirmationProps = {
  dataFields: DataField[];
  headerMapping: HeaderMappingEntry[];
  previewDamage: PreviewDamage;
  setStep: (step: number) => void;
  handleSubmit: () => void;
  isSubmitting?: boolean;
};

export const Confirmation: React.FunctionComponent<ConfirmationProps> = ({
  dataFields,
  previewDamage,
  headerMapping,
  setStep,
  handleSubmit,
  isSubmitting = false,
}) => (
  <>
    <p>Preview of first created damage</p>
    {headerMapping.map(({ fileHeader, schemaFieldId }) => (
      <Row key={schemaFieldId}>
        <Col flex="1" />
        <Col flex="auto">
          <LabelText>{dataFields?.find(({ key }) => key === schemaFieldId)?.label}:</LabelText>
        </Col>
        <Col flex="50%">
          <ValueText>{fileHeader ? previewDamage[fileHeader] : ''}</ValueText>
        </Col>
        <Col flex="50px" />
      </Row>
    ))}
    <ModalActionButtons>
      <Button
        onClick={() => {
          setStep(STEPS.mapping);
        }}
      >
        Back
      </Button>
      <Button type="primary" onClick={handleSubmit} disabled={isSubmitting} loading={isSubmitting}>
        Create
      </Button>
    </ModalActionButtons>
  </>
);
